import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import '../styles/contact-form.css';

const ContactForm = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    email: '',
    need: 'Infrastructure & Réseaux',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess(false);

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/contacts`, formData);
      setSuccess(true);
      setFormData({
        name: '',
        company: '',
        email: '',
        need: 'Infrastructure & Réseaux',
        message: ''
      });
      setTimeout(() => setSuccess(false), 5000);
    } catch (err) {
      setError(err.response?.data?.error || t('contact.form.error'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className="contact-form" onSubmit={handleSubmit}>
      <div className="form-row">
        <div className="form-group">
          <label>{t('contact.form.name')}</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder={t('contact.form.name')}
            required
          />
        </div>
        <div className="form-group">
          <label>{t('contact.form.company')}</label>
          <input
            type="text"
            name="company"
            value={formData.company}
            onChange={handleChange}
            placeholder={t('contact.form.company')}
          />
        </div>
      </div>

      <div className="form-group">
        <label>{t('contact.form.email')}</label>
        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          placeholder={t('contact.form.email')}
          required
        />
      </div>

      <div className="form-group">
        <label>{t('contact.form.need')}</label>
        <select name="need" value={formData.need} onChange={handleChange}>
          <option>Infrastructure & Réseaux</option>
          <option>Cybersécurité</option>
          <option>Développement logiciel</option>
          <option>Télécoms & Connectivité</option>
          <option>Conseil & Transformation</option>
        </select>
      </div>

      <div className="form-group">
        <label>{t('contact.form.message')}</label>
        <textarea
          name="message"
          value={formData.message}
          onChange={handleChange}
          placeholder={t('contact.form.message')}
          rows="3"
          required
        />
      </div>

      {error && <div className="form-error">{error}</div>}
      {success && <div className="form-success">{t('contact.form.success')}</div>}

      <button type="submit" className="btn-submit" disabled={loading}>
        {loading ? t('common.loading') : t('contact.form.submit')}
      </button>

      <p className="form-disclaimer">
        Réponse sous 24–48h ouvrées · Vos données restent confidentielles.
      </p>
    </form>
  );
};

export default ContactForm;
